/**
 * Shop The Look Section
 * Handles hotspot button clicks and product card switching
 */

class ShopTheLookSection extends HTMLElement {
  constructor() {
    super();
    
    this.hotspotButtons = this.querySelectorAll('.hotspot-button');
    this.productCards = this.querySelectorAll('.shop-the-look__product-card');
    this.currentActiveIndex = 0;
    
    this.init();
  }
  
  init() {
    if (this.hotspotButtons.length === 0 || this.productCards.length === 0) {
      return;
    }
    
    // Add click event listeners to hotspot buttons
    this.hotspotButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.handleHotspotClick(index));
    });
    
    // Set first hotspot and card as active
    if (this.hotspotButtons.length > 0) {
      this.setActiveHotspot(0);
    }
    
    // Prevent swatch links from navigating on mobile
    this.preventSwatchNavigation();
  }
  
  handleHotspotClick(index) {
    // If clicking the already active hotspot, do nothing
    if (index === this.currentActiveIndex) {
      return;
    }
    
    // Update active states
    this.setActiveHotspot(index);
    this.setActiveProductCard(index);
    
    this.currentActiveIndex = index;
  }
  
  setActiveHotspot(index) {
    // Remove active class from all hotspots
    this.hotspotButtons.forEach(button => {
      button.classList.remove('is-active');
    });
    
    // Add active class to clicked hotspot
    if (this.hotspotButtons[index]) {
      this.hotspotButtons[index].classList.add('is-active');
    }
  }
  
  setActiveProductCard(index) {
    // Remove active class from all product cards
    this.productCards.forEach(card => {
      card.classList.remove('is-active');
    });
    
    // Add active class to corresponding product card
    if (this.productCards[index]) {
      this.productCards[index].classList.add('is-active');
    }
  }
  
  preventSwatchNavigation() {
    // On mobile, prevent swatch links from navigating to product pages
    if (window.innerWidth <= 768) {
      const swatchLinks = this.querySelectorAll('.shop-the-look__product-card product-swatches a, .shop-the-look__product-card .swatch a');
      
      swatchLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Get the variant ID or URL from the link
          const url = new URL(link.href);
          const variantParam = url.searchParams.get('variant');
          
          if (variantParam) {
            // Update the current URL without navigating
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('variant', variantParam);
            window.history.replaceState({}, '', currentUrl);
            
            // Trigger any swatch selection styling if needed
            const swatchElement = link.closest('.swatch');
            if (swatchElement) {
              const allSwatches = swatchElement.parentElement.querySelectorAll('.swatch');
              allSwatches.forEach(s => s.classList.remove('selected'));
              swatchElement.classList.add('selected');
            }
          }
        });
      });
    }
  }
}

// Register custom element
if (!customElements.get('shop-the-look-section')) {
  customElements.define('shop-the-look-section', ShopTheLookSection);
}

// Initialize sections on page load
function initShopTheLookSections() {
  const sections = document.querySelectorAll('shop-the-look-section');
  sections.forEach(section => {
    if (!section.initialized) {
      section.initialized = true;
    }
  });
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShopTheLookSections);
} else {
  initShopTheLookSections();
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('shop-the-look-section');
    if (section && !section.initialized) {
      section.initialized = true;
    }
  });
  
  document.addEventListener('shopify:section:reorder', function() {
    initShopTheLookSections();
  });
}